import { render } from "./component-dop-okved.vue?vue&type=template&id=0277959f"
import script from "./component-dop-okved.vue?vue&type=script&setup=true&lang=js"
export * from "./component-dop-okved.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-card/field-wrappers/component-dop-okved.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0277959f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0277959f', __exports__)) {
    api.reload('0277959f', __exports__)
  }
  
  module.hot.accept("./component-dop-okved.vue?vue&type=template&id=0277959f", () => {
    api.rerender('0277959f', render)
  })

}


export default __exports__